var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "36px",
    viewBox: "0 0 30 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "plant") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "createneworder",
    transform: "translate(-734.000000, -639.000000)",
    fill: "#535353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "samplenumber",
    transform: "translate(152.000000, 539.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plant_card",
    transform: "translate(512.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plant",
    transform: "translate(70.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.84284444,13.85604 C11.4019556,12.03804 11.2099556,9.28584 9.4144,7.70724 C7.62062222,6.13044 0.0952888889,5.28624 0.0952888889,5.28624 C0.0952888889,5.28624 1.6064,12.38364 3.77351111,14.28804 C5.56906667,15.86484 8.28551111,15.67044 9.84284444,13.85604",
    id: "Fill-621"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7768889,16.32798 C16.7768889,15.74658 16.9582222,15.07878 17.2835556,14.39478 C19.7351111,16.00578 23.0435556,15.69978 25.1608889,13.49658 C27.5697778,10.99458 29.4044444,0.00918 29.4044444,0.00918 C29.4044444,0.00918 19.1075556,1.64178 16.2008889,4.66578 C14.4231111,6.51438 13.9964444,9.17838 14.8835556,11.43018 C13.7635556,13.08618 13.2213333,14.84298 13.2213333,16.32798 L13.2213333,21.60018 L16.7768889,21.60018 L16.7768889,16.32798 Z",
    id: "Fill-622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0867556,23.4009 L4.91075556,23.4009 C4.35253333,23.4009 3.82808889,23.6673 3.49208889,24.1173 C3.15608889,24.5673 3.04942222,25.1523 3.20231111,25.6959 L5.74275556,34.6959 C5.95964444,35.4681 6.65653333,36.0009 7.4512,36.0009 L22.5463111,36.0009 C23.3409778,36.0009 24.0378667,35.4681 24.2565333,34.6959 L26.7969778,25.6959 C26.9498667,25.1523 26.8414222,24.5673 26.5054222,24.1173 C26.1694222,23.6673 25.6449778,23.4009 25.0867556,23.4009",
    id: "Fill-623"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant);
export default __webpack_public_path__ + "static/media/plant.4b351a2d96e72a81a239fb7b33e2eff1.svg";
export { ForwardRef as ReactComponent };